import Vue from "vue";
import axios from "axios";

// 创建axios实例
const requestservice = axios.create({
  // baseURL: 'https://master.yanyi.live/appapi/', // 设置基本的URL前缀
  baseURL: process.env.VUE_APP_BASE_API,
});

// 添加请求拦截器
requestservice.interceptors.request.use(
  (config) => {
    console.log("请求地址", config.url, process.env.VUE_APP_BASE_API);
    // 在发送请求之前做一些处理
    // 例如，可以在请求头中添加token
    // config.headers.Authorization = 'Bearer ' + getToken();
    let language = localStorage.getItem("lang");
    if (language === "zhTW") {
      language = "zh-TW";
    } else if (language === "zhCN") {
      language = "zh-CN";
    }
    config.headers["Language"] = language;

    return config;
  },
  (error) => {
    // 处理请求错误
    return Promise.reject(error);
  },
);

// 响应拦截器
requestservice.interceptors.response.use(
  function (response) {
    // 在接收响应数据之前做些什么，比如对返回的数据进行处理等
    return response;
  },
  function (error) {
    // 处理响应错误
    return Promise.reject(error);
  },
);

Vue.prototype.$http = requestservice;
export default requestservice;
